import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import {
	getAttentionDashboard,
	updateAttentionDashboard,
} from '../../thunks/attention_dashboard_thunks';
import { withUserType } from '../withUserType';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { savedFilterViewsRestCrudThunksForSupplier } from '../../thunks/saved_filter_views_thunks';
import { SUPPLIER_BASE_VIEW_OPTIONS } from '../../utils/DataConstants';
import {
	useWorkOrdersViewTabs,
	WORK_ORDERS_OVERVIEW_TABS_COLLECTION,
} from '../work_orders_overview_page/useViewTabs';

const SUPPLIER_OVERVIEW_PATH = '/supplier/workOrders/overview';
const { Content } = Layout;
const style = require('./SupplierWorkOrdersOverviewPage.less');

const SupplierWorkOrdersOverviewPage = ({
	companyConfig,
	childRoutes,
	defaultView,
	getWorkOrderDefaultView,
	fetchWorkOrderViews,
	workOrderViews,
	workOrderViewsLoading,
	attentionDashboards,
	saveAttentionDashboard,
}) => {
	const { loading, redirectTarget, tabs, handleTabChange, checkTabActive, tabsRightActions } =
		useWorkOrdersViewTabs({
			basePath: SUPPLIER_OVERVIEW_PATH,
			baseViewOptions: SUPPLIER_BASE_VIEW_OPTIONS,
			defaultView,
			workOrderViews,
			workOrderViewsLoading,
			attentionDashboards,
			saveAttentionDashboard,
			fetchWorkOrderViews,
			getWorkOrderDefaultView,
		});

	if (loading) return null;
	return (
		<div>
			<ScrollToTopOnMount />
			<div>
				<Route
					path={SUPPLIER_OVERVIEW_PATH}
					exact
					render={() => <Redirect to={redirectTarget} />}
				/>
				<Content className="workOrdersPage" style={{ padding: '0 0.5em' }}>
					<div
						style={{
							margin: '0 -8px',
							padding: '24px',
							paddingBottom: 0,
							background: nullSafeGet('detail.config.theme.navblock', companyConfig),
							marginBottom: 8,
						}}
					>
						<div style={{ marginBottom: 24 }}>
							<h4
								style={{
									color: 'rgba(255, 255, 255, 0.9)',
									marginRight: 8,
									marginBottom: 0,
								}}
							>
								Work Orders
							</h4>
						</div>
						<SubnavTabs
							tabs={tabs}
							onChange={handleTabChange}
							isActive={checkTabActive}
							tabsRightActions={tabsRightActions}
							className="items-center justify-start"
						/>
					</div>
					{childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		</div>
	);
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	getWorkOrderDefaultView: () => getAttentionDashboard(dispatch, ownProps.userType),
	fetchWorkOrderViews: (
		params,
		targetCollectionName = WORK_ORDERS_OVERVIEW_TABS_COLLECTION,
		pagination = { current: 1, pageSize: 100 },
		sorting?,
		filters?
	) =>
		dispatch(
			savedFilterViewsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters
			)
		),
	saveAttentionDashboard: (entity) => updateAttentionDashboard(dispatch, ownProps.userType, entity),
});

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	defaultView: state.session.defaultView,
	workOrderViews: getRecordsForTargetCollection(
		state.saved_filter_views,
		WORK_ORDERS_OVERVIEW_TABS_COLLECTION
	),
	workOrderViewsLoading: nullSafeGet(
		`${WORK_ORDERS_OVERVIEW_TABS_COLLECTION}.fetching`,
		state.saved_filter_views
	),
	attentionDashboards: state.attention_dashboards.detail,
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(SupplierWorkOrdersOverviewPage))
);
